import { makeStyles } from '@mui/styles';
import { ApplicationMuiTheme } from '@tassat/payments-themes/dist/types/theme';

export default makeStyles((theme: ApplicationMuiTheme) => ({
    container: {
        backGroundColor: theme?.app?.applicationColors.enumColors.offWhite || '#f1f1f7',
        padding: '2rem',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#CCC'}`,
        borderRadius: '5px',
        boxShadow: `0 2px 4px 0 ${theme?.app?.applicationColors.enumColors.greyLighter || 'rgba(0, 0, 0, 0.4)'}`,
        maxWidth: '500px'
    },
    buttonContainer: {
        display: 'flex' as const,
        alignItems: 'center' as const,
        justifyContent: 'center' as const
    },
    button: {
        margin: '0 20px',
        background: theme?.app?.clientTheme.colors.primaryColorDark || '#0a2241',
        borderRadius: '5px',
        color: theme?.app?.applicationColors.enumColors.white || '#fff',
        padding: '5px 15px'
    }
}));